import React from 'react';

import { Chip, Stack, Tooltip, Typography } from '@mui/material';

import { LIST_VISIBILITY, LUX_PLUS_SCHEDULE } from '~/consts/schedule';

import { formatDateSlashesWithClock } from '~/services/TimeService';

import { getScheduleTypeLabel } from './campaignScheduleHistoryDisplay';
import type { BrandSchedule, CampaignScheduleDateEntry } from './types';

// list_visibility and lux_plus both gate search/carousel/homepage visibility, so both get the same
// pill; the row's Type chip already distinguishes LuxPlus+ rows.
const PILL_CONFIG: Partial<
  Record<BrandSchedule['type'], { color: 'warning' | 'default' | 'primary'; tooltip: string }>
> = {
  [LIST_VISIBILITY]: { color: 'primary', tooltip: 'Visible in search, carousels, and homepage' },
  [LUX_PLUS_SCHEDULE]: { color: 'primary', tooltip: 'Visible in search, carousels, and homepage' },
};

interface Props {
  entry: CampaignScheduleDateEntry;
}

export default function CampaignScheduleDateEntryPill({ entry }: Props) {
  const pillConfig = PILL_CONFIG[entry.type];

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      {pillConfig && (
        <Tooltip arrow title={pillConfig.tooltip}>
          <Chip
            color={pillConfig.color}
            // Always "List Visibility", not entry.type — a lux_plus entry's Type chip already says
            // LuxPlus+, so this pill names what the date range actually controls, not the brand row's type.
            label={getScheduleTypeLabel(LIST_VISIBILITY)}
            size="small"
            variant="outlined"
          />
        </Tooltip>
      )}
      <Typography variant="body2">
        {formatDateSlashesWithClock(entry.start)} → {formatDateSlashesWithClock(entry.end)}
      </Typography>
    </Stack>
  );
}
